import { useEffect, useRef } from 'react'

import { useFormContext } from 'react-hook-form'

import { SOURCE_FIELDS, updateValues } from 'reducers/form/campaign-edit'

const DERIVED_FIELDS = ['totalBudget', 'dailyBudget', 'goalImpressions', 'goalRtbImpressions', 'extraViewsPercent']

// RHF port of the campaign-edit redux-form reducer plugin: recompute derived budget fields on mount and on any source-field change.
// Derived fields are also source fields, so the `updating` flag (not the changed-value check, which fails on NaN) blocks re-entrancy — RHF fires the watch synchronously inside setValue.
export const useCampaignDerivedFields = () => {
  const { getValues, setValue, watch } = useFormContext()
  const updating = useRef(false)

  useEffect(() => {
    const applyDerived = (field: string) => {
      updating.current = true
      try {
        const current = getValues()
        const next = updateValues(field, current)
        DERIVED_FIELDS.forEach(name => {
          if (next[name] !== current[name]) setValue(name, next[name])
        })
      } finally {
        updating.current = false
      }
    }

    applyDerived('dailyBudget')

    const subscription = watch((_values, { name }) => {
      if (updating.current || !name || !SOURCE_FIELDS.includes(name)) return
      applyDerived(name)
    })

    return () => subscription.unsubscribe()
  }, [getValues, setValue, watch])
}
